var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0"},_vm._l((_vm.codes),function(code){return _c('CodeRow',{key:code.code,attrs:{"code":code},on:{"reset-code":_vm.resetCode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }